import * as actions from './actions';

export default {
  strict: true,
  state: {
    isFetchingWaiverContents: false,
  },
  actions,
  mutations: {
    'waiverContents/set': (state, { path, value }) => {
      state[path] = value;
    },
  },
};
